/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import _ from 'lodash';

export enum BlockUnits {
  EightKB = '8kB',
}

export enum Context {
  Internal = 'internal',
  Postmaster = 'postmaster',
  Sighup = 'sighup',
  SuperuserBackend = 'superuser-backend',
  Backend = 'backend',
  Superuser = 'superuser',
  User = 'user',
}

export enum MemoryUnits {
  Bytes = 'B',
  Kilobytes = 'kB',
  Megabytes = 'MB',
  Gigabytes = 'GB',
  Terabytes = 'TB',
}
export enum TimeUnits {
  Microseconds = 'us',
  Milliseconds = 'ms',
  Seconds = 's',
  Minutes = 'min',
  Hours = 'h',
  Days = 'd',
}

export const PgConfigValueWithUnit = new RegExp(
  `^(\\D*\\d+)(${[..._.values(TimeUnits), ..._.values(BlockUnits), ..._.values(MemoryUnits)].join('|')})$`,
);
